import { useQuery } from "react-query";
import { getFranchiseEmployees } from "../../../../../actions/CarrierAgreementMgmt/FranchiseEmployee";

export const useFranchiseEmployee = () => {
  return useQuery("GetFranchiseEmployee", getFranchiseEmployees, {
    refetchOnWindowFocus: false,
  });
};
